<template>
  <div class="event-chip" :style="{ '--event-color': event.color || '#2563eb' }">
    <div class="event-chip__title">
      {{ event.programName || "Program Event" }}
    </div>
    <div class="event-chip__meta">
      <span>{{ event.etStart }}E.C - {{ event.etEnd }}E.C</span>
      <span class="event-chip__dot"></span>
      <span>{{ event.cpdProvider || "Unknown CPD Provider" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['event'],
};
</script>

<style scoped>
.event-chip {
  position: relative;
  height: 100%;
  padding: 6px 10px 6px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.3);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  overflow: hidden;
}

.event-chip::before {
  content: "";
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 6px;
  width: 3px;
  border-radius: 999px;
  background: var(--event-color);
}

.event-chip__title {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-chip__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  color: #64748b;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-chip__dot {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #94a3b8;
  flex-shrink: 0;
}
</style>
